import { render } from "./Product1View.vue?vue&type=template&id=5178e48b"
import script from "./Product1View.vue?vue&type=script&lang=js"
export * from "./Product1View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__